import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadTransactions (params) {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/atp/transactions/', { params }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async getTransactionDetail (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/transactions/${id}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
